import { r4Client, r4Error } from '@/services'

const CustomerAppendsApi = {
  async list () {
    try {
      const resp = await r4Client().get('/api/v1/query_engine/customer_appends')
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async create (appendData) {
    try {
      const resp = await r4Client().post('/api/v1/query_engine/customer_appends', appendData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async get (customerId) {
    try {
      const resp = await r4Client().get(`/api/v1/query_engine/customer_appends/${customerId}`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default CustomerAppendsApi
